import { render, staticRenderFns } from "./UploadEvidents.vue?vue&type=template&id=147916a8&scoped=true&"
import script from "./UploadEvidents.vue?vue&type=script&lang=ts&"
export * from "./UploadEvidents.vue?vue&type=script&lang=ts&"
import style0 from "./UploadEvidents.vue?vue&type=style&index=0&id=147916a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147916a8",
  null
  
)

export default component.exports